import React, { useState } from 'react';
import Modal from '../shared/Modal';
import { SelectField, TextField, SegmentedField } from '../shared/FormField';
import { INSTITUTION_TYPES } from '../data/enums';
import { useLocationOptions } from '../shared/useLocationOptions';

const blank = { name: '', institution_type: '', state: '' };
const parseError = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  'Unable to create institution.';

export default function CreateInstitutionModal({ isOpen, onClose, onCreate }) {
  const [form, setForm] = useState(blank);
  const [status, setStatus] = useState('idle');
  const [errMsg, setErrMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { stateOptions } = useLocationOptions();
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    if (submitting) return;
    if (!form.name.trim() || !form.institution_type) return;
    setSubmitting(true);
    setStatus('idle');
    setErrMsg('');
    try {
      await onCreate({
        name: form.name.trim(),
        institution_type: form.institution_type,
        state: form.state.trim() || null,
      });
      setStatus('success');
    } catch (error) {
      setErrMsg(parseError(error));
      setStatus('error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setForm(blank);
    setStatus('idle');
    setErrMsg('');
    onClose();
  };

  return (
    <Modal
      title="Create Institution"
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={submit}
      status={status}
      errorMessage={errMsg}
      onContinue={handleClose}
      submitLabel="Create"
      successTitle="Institution Created"
      successMessage="The institution was saved to the backend."
      isSubmitting={submitting}
    >
      <TextField label="Institution Name" required value={form.name} onChange={set('name')}
        placeholder="Enter official institution name" />
      <SegmentedField label="Institution Type" required value={form.institution_type}
        onChange={set('institution_type')} options={INSTITUTION_TYPES} />
      <SelectField
        label="State"
        value={form.state}
        onChange={set('state')}
        options={stateOptions}
        placeholder="Select State (optional)"
        note="Leave blank for federal-scope institutions."
      />
    </Modal>
  );
}
